class Constants {

    BASE_URL = "https://www.tus-ventas-facil.com/api/"
    BASE_REPORT = "https://www.tus-ventas-facil.com"
    //BASE_URL = "http://18.231.117.163:8005/api/"

    DOCUMENT_TYPES = [
        {
            id: 1, description: "DNI"
        }, {
            id: 2, description: "RUC"
        }, {
            id: 3, description: "SIN DOCUMENTO"
        }
    ]
    ROLES = [
        {
            id: 1, description: "ADMINISTRADOR"
        }, {
            id: 2, description: "VENDEDOR"
        }
    ]
    DOCUMENT_TYPES_SELLER = [
        {
            id: 1, description: "DNI"
        }, {
            id: 2, description: "TARJETA EXTRANJERA"
        }, {
            id: 3, description: "SIN DOCUMENTO"
        }
    ]
}

export default new Constants()

